var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.49895 0.84082C4.07991 0.84082 2.11328 2.80745 2.11328 5.22649C2.11328 7.59936 3.96911 9.51982 6.38815 9.60292C6.46202 9.59369 6.53588 9.59369 6.59128 9.60292C6.60974 9.60292 6.61898 9.60292 6.63744 9.60292C6.64668 9.60292 6.64668 9.60292 6.65591 9.60292C9.01955 9.51982 10.8754 7.59936 10.8846 5.22649C10.8846 2.80745 8.91799 0.84082 6.49895 0.84082Z",
    fill: "#00E194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1903 12.0595C8.61434 10.3422 4.41336 10.3422 1.8189 12.0595C0.646309 12.8443 0 13.9061 0 15.0417C0 16.1774 0.646309 17.23 1.80966 18.0055C3.10228 18.8734 4.80111 19.3074 6.49998 19.3074C8.19885 19.3074 9.89772 18.8734 11.1903 18.0055C12.3537 17.2207 13 16.1682 13 15.0233C12.9908 13.8876 12.3537 12.8351 11.1903 12.0595Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicUser);
export default __webpack_public_path__ + "static/media/tic_user.42ea900f4c239e91e32b024074487f69.svg";
export { ForwardRef as ReactComponent };